import React from 'react';


import { BrowserRouter, Route, Redirect } from 'react-router-dom';

import {Layout} from 'antd';
import 'antd/dist/antd.css'


import './styles/Globals.css';

import PublicRoutes from "./Routes/PublicRoutes";
import AdminRoutes from "./Routes/AdminRoutes";
import Auth from "./Routes/Middleware/Auth"

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        Auth === true
            ? <Component {...props} />
            : <Redirect to='/login' />
    )} />
)

function App() {
    return (
        <BrowserRouter>
            <Layout className="layout main-container">
                <PrivateRoute path='/admin' >
                    <AdminRoutes />
                </PrivateRoute>
                 <PublicRoutes />
            </Layout>
        </BrowserRouter>
    );
}

export default App;
